export default __webpack_public_path__ + "static/activities_image_two-bae1eead41f3bb4ea883ff7d5ba31ad6.png";